module.exports = __webpack_public_path__ + "img/two-factor-phone.5202bab8.svg";